import { render } from "./WebinarsView.vue?vue&type=template&id=0e117150&lang=true"
import script from "./WebinarsView.vue?vue&type=script&lang=js"
export * from "./WebinarsView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__